interface AdminSidebarOpenerProps {
  onOpen: () => void;
}

export function AdminSidebarOpener({ onOpen }: AdminSidebarOpenerProps): JSX.Element {
  return (
    <button className="admin-sidebar-opener" type="button" onClick={onOpen} aria-label="Show sidebar">
      »
    </button>
  );
}
